<template>
  <div class="firstStep" v-loading="formLoading">
    <el-form
      :model="extForm"
      :rules="rules"
      ref="ruleForm"
      label-width="60px"
      class="demo-ruleForm"
    >
      <div class="masterDataInformation">
        <el-row>
          <el-col :span="12">
            <!-- 注册联系人： -->
            <el-form-item
              :label="$t('subcontractor.authUserName')"
              :label-width="languagezh_cn ? '160px' : '225px'"
              prop="authUserName"
            >
              <el-input v-model="extForm.authUserName" maxlength="18"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="isDomestic">
            <!-- 注册人邮箱： -->
            <el-form-item
              :label="$t('subcontractor.registerEmail')"
              :label-width="languagezh_cn ? '160px' : '225px'"
              prop="registerEmail"
            >
              <el-input v-model="extForm.registerEmail" maxlength="30"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="!isDomestic">
            <!-- 登录账号： -->
            <el-form-item
              :label="$t('subcontractor.subconUserName')"
              :label-width="languagezh_cn ? '160px' : '225px'"
              prop="subconUserName"
            >
              <el-input v-model="extForm.subconUserName" maxlength="30"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <!-- 注册证件： -->
            <el-form-item
              :label="$t('subcontractor.cardType')"
              :label-width="languagezh_cn ? '160px' : '225px'"
              prop="cardType"
            >
              <!-- 请选择证件类型 -->
              <el-select
                v-model="extForm.cardType"
                :placeholder="$t('subcontractor.placeholderTip.cardTypePlc')"
                @change="$forceUpdate()"
              >
                <!-- 身份证 -->
                <el-option :label="$t('subcontractor.cardTypeOptions.idCard')" :value="0"></el-option>
                <!-- 护照 -->
                <el-option :label="$t('subcontractor.cardTypeOptions.passport')" :value="1"></el-option>
                <!-- 其他 -->
                <el-option :label="$t('subcontractor.cardTypeOptions.other')" :value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <!-- 注册人证件号码： -->
            <el-form-item
              :label="$t('subcontractor.authPersonIdCard')"
              :label-width="languagezh_cn ? '160px' : '225px'"
              prop="authPersonIdCard"
            >
              <!-- 请输入注册人证件号码 -->
              <el-input
                v-model="extForm.authPersonIdCard"
                oninput="value=value.replace(/[^0-9a-zA-Z.]/g,'')"
                :placeholder="$t('subcontractor.placeholderTip.authPersonIdCardPlc')"
                maxlength="18"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12" v-if="isDomestic">
            <!-- 统一社会信用代码： -->
            <el-form-item
              :label="$t('subcontractor.unifyCode')"
              :label-width="languagezh_cn ? '160px' : '225px'"
              prop="unifiedCreditCode"
            >
              <el-input
                v-on:blur="searInpt"
                v-model="extForm.unifiedCreditCode"
                maxlength="20"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <!-- 分包商名称： -->
            <el-form-item
              :label="$t('subcontractor.supplierName')"
              :label-width="languagezh_cn ? '160px' : '225px'"
              prop="supplierName"
            >
              <el-input
                :disabled="isDomestic"
                v-loading="loadWaite"
                v-model="extForm.supplierName"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12" v-if="isDomestic">
            <!-- 注册手机号： -->
            <el-form-item :label="$t('subcontractor.phone')" :label-width="languagezh_cn ? '160px' : '225px'" prop="phone">
              <el-input v-model="extForm.phone" maxlength="11"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="!isDomestic">
            <!-- 注册人邮箱： -->
            <el-form-item
              :label="$t('subcontractor.registerEmail')"
              :label-width="languagezh_cn ? '160px' : '225px'"
              prop="registerEmail"
            >
              <el-input v-model="extForm.registerEmail" maxlength="30"></el-input>
              <span style="color: red;">{{ $t('subcontractor.emailPrompt') }}</span>
            </el-form-item>
          </el-col>
          <!--  -->
          <el-col :span="12" style="display: flex">
            <el-form-item
              class=""
              :label="$t('subcontractor.verificationCode')"
              :label-width="languagezh_cn ? '160px' : '225px'"
              prop="verificationCode"
            >
              <div class="verificationCode" style="position: relative">
                <el-input
                  style="width: 165px"
                  v-model="extForm.verificationCode"
                ></el-input
                ><el-button
                  class="send"
                  style="background: red"
                  @click="sendVerification"
                  :disabled="disabled"
                  >{{ count > 0 ? count + $t('subcontractor.miaoBtn') : $t('subcontractor.sendBtn') }}</el-button
                >
                <div class="islider" v-if="isCode">
                  <Slider
                    @close="
                      isCode = false;
                      disabled = false;
                    "
                    :log="true"
                    @getImg="getImg"
                    @validImg="validImg"
                  ></Slider>
                </div>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label-width="516px" class="confirmButton">
          <!-- 确 定 -->
          <el-button @click="submitForms('ruleForm')">{{ $t('subcontractor.confirmBtn') }}</el-button>
        </el-form-item>
      </div>
    </el-form>
    <el-dialog
      title="选择合作单位"
      :visible.sync="centerDialogVisible"
      width="30%"
      center
    >
      <treeBox ref="msgFormSon"></treeBox>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="getTreeItem">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  registinformation,
  qryTycSearch,
  sendVerificationCode,
  checkContactByMobile,
  getImageVerifyCode,
  checkSendEmailCode,
  checkEmailVerificationCode
} from "@/api/subcontractor-register";

import treeBox from "../components/cooperativeUnitTree.vue";
import { formatDate } from "@/utils";
import Slider from "@/views/common/slider";
import Cookies from "js-cookie";
import Setting from "@/config/index";
const savedLocaleKey = Setting.i18n.cookieLable;
export default {
  props: {
   
    subconBaseInfo: {},
    registerForm: {},
  },
  components: {
    treeBox,
    Slider,
  },
  data() {
    return {
      extForm: {
        // 姓名
        authUserName: "",
          // 手机号
          phone: "",
          // 密码
          password: "",
          // 二次确认密码
          secondaryPassword: "",
          // 供应商名称
          supplierName: "",
          // 信用代码
          unifiedCreditCode: "",
          // 合作单位
          cooUnitName: "",
          authCertificate: "",
          // 合作单位编码
          cooUnitCode: "",
          // 合作单位id
          cooUnitId: "",
          // 验证码
          verificationCode: "",
          isAuthCertificate: "1",
          cardType: "", // 证件类型
          authPersonIdCard: "", // 证件号码
          registerEmail: "", // 邮箱
          unifiedCreditCode: "", // 信用代码
          subconUserName: "", // 登录账号
      },
      formLoading: false,
      loadWaite: false,
      isCode: false,
      count: "",
      timer: "",
      disabled: false,
      centerDialogVisible: false,
      __resizeHandler: null,
      value: [],
      treeParams: {
        parentId: "",
        flag: 0,
        isOran: "0",
        isOrganAll: "0",
      },
      // 用户id
      // 分包商变更id
      // 分包商id
      // 注册证件
      // 注册人证件号码
      // 注册邮箱
      // 法人代表授权委托书
      rules: {
        // 请输入注册联系人  请输入2-18个中文汉字
        authUserName: [
          { required: true, message: this.$t("subcontractor.verifyTip.authUserName"), trigger: "blur" },
          {
            pattern: 
              this.$route.query.type == 'domestic'
                ? /^[\u4e00-\u9fa5]{2,18}$/
                : "",
            message: this.$t("subcontractor.verifyTip.authUserNameVerify"),
            trigger: "change"
          },
        ],
        // 请输入注册手机号  手机号码输入错误
        phone: [
          { required: true, message: this.$t("subcontractor.verifyTip.phone"), trigger: "blur" },
          {
            pattern: 
              (Cookies.get(savedLocaleKey) === "zh-cn") === undefined ||
              Cookies.get(savedLocaleKey) === "zh-cn"
                ? /^1\d{10}$/
                : "",
            message: this.$t("subcontractor.verifyTip.phoneVerify"),
          },
        ],
        // 请输入注册人邮箱  只支持输入邮箱格式
        registerEmail: [
          { required: true, message: this.$t("subcontractor.verifyTip.registerEmail"), trigger: "blur" },
          {
            required: false,
            pattern: /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/,
            message: this.$t("subcontractor.verifyTip.registerEmailVerify"),
            trigger: "blur"
          }
        ],
        // 登录账号
        subconUserName: [
          { required: true, message: this.$t("subcontractor.verifyTip.subconUserNameTip"), trigger: "blur" },
          {
            pattern: 
              this.$route.query.type != 'domestic'
                ? /[^\u4E00-\u9FA5]/
                : "",
            message: this.$t("subcontractor.verifyTip.subconUserNameVerify"),
            trigger: "blur"
          }
        ],
        // 请选择注册证件
        cardType: [
          { required: true, message: this.$t("subcontractor.verifyTip.cardType"), trigger: "change" },
        ],
        // 请输入注册人证件号码  请输入正确的证件号码
        authPersonIdCard: [
          { required: true, message: this.$t("subcontractor.verifyTip.authPersonIdCard"), trigger: "blur" },{
            min: 9,
            max: 18,
            required: true,
            message: this.$t("subcontractor.verifyTip.authPersonIdCardVerify"),
            trigger: "blur",
          },
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "change" },
        ],
        secondaryPassword: [
          { required: true, message: "请输入确认密码", trigger: "change" },
        ],
        // 请输入分包商名称
        supplierName: [
          { required: true, message: this.$t("subcontractor.verifyTip.supplierName"), trigger: "change" },
        ],
        // 请输入正确的统一社会信用代码  长度为18位
        unifiedCreditCode: [
          // /.{2,18}/
          {
            required: true,
            message: this.$t("subcontractor.verifyTip.unifiedCreditCodeVerify"),
            trigger: "change",
          },

          { max: 18, message: this.$t("subcontractor.verifyTip.unifiedCreditCodeVerify"), trigger: "change" },
        ],
        // 请输入合作单位
        cooUnitName: [
          { required: true, message: this.$t("subcontractor.verifyTip.cooUnitName"), trigger: "change" },
        ],
        // 请输入验证码
        verificationCode: [
          { required: true, message: this.$t("subcontractor.verifyTip.verificationCode"), trigger: "change" },
        ],
      }
    };
  },
  computed: {
    isDomestic() {
      return this.$route.query.type ? this.$route.query.type === 'domestic' : true;
    },
  },
  mounted(){
    this.$route.query.type = this.$route.query.type || 'domestic';
  },
  methods: {
    isdecimal(val) {
      let y = String(val).indexOf(".") + 1; //获取小数点的位置
      let count = String(val).length - y; //获取小数点后的个数
      if (y > 0) {
        return true;
      } else {
        return false;
      }
    },
    submitForms(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // 境内注册
          if(this.$route.query.type === 'domestic') {
            qryTycSearch({ word: this.extForm.unifiedCreditCode }).then((res) => {
              this.loadWaite = false;
              if (res.data.code === "0") {
                if (res.data.data.result) {
                  const info = res.data.data.result;
                  this.extForm.supplierName = info.name;
                  this.submitForm(formName);
                } else {
                  this.$message({
                    showClose: true,
                    type: "error",
                    message: "统一社会信用代码查询失败",
                    ccuiCustom: true,
                  });
                }
              }
            });
          }
          // 境外注册
          if(this.$route.query.type === 'overseas') {
            this.submitForm(formName);
          }
        }else {
          this.$emit("open");
          console.log("error submit!!");
          return false;
        }
      })
    },
    // 提交第一步
    submitForm(formName) {
      this.extForm.isOverseas = this.$route.query.type == 'overseas' ? 1 : 0;
      this.extForm.languageFlag = Cookies.get(savedLocaleKey);
      // 境内注册
      if(this.$route.query.type === 'domestic') {
        // 校验验证码
        checkContactByMobile({
          mobile: this.extForm.phone,
          inputAuthCode: this.extForm.verificationCode,
        }).then((res) => {
          if (res.data.message === "成功") {
            this.extForm.createTime = "";
            this.extForm.updateTime = "";
            this.formLoading = true;
            registinformation(this.extForm).then(
              (res) => {
                this.formLoading = false;
                if (res.data.code === "0") {
                  this.$router.push("/subcon-submit-success");
                } else {
                  this.$message({
                    showClose: true,
                    message: res.data.message,
                    type: "warning",
                  });
                }
              },
              (error) => {
                this.formLoading = false;
              }
            );
          }
        });
      }
      // 境外注册
      if(this.$route.query.type === 'overseas') {
        checkEmailVerificationCode({
          email: this.extForm.registerEmail,
          verificationCode: this.extForm.verificationCode
        }).then((res) => {
          if (res.data.message === "成功") {
            this.extForm.createTime = "";
            this.extForm.updateTime = "";
            this.formLoading = true;
            registinformation(this.extForm).then(
              (res) => {
                this.formLoading = false;
                if (res.data.code === "0") {
                  this.$router.push("/subcon-submit-success");
                } else {
                  this.$message({
                    showClose: true,
                    message: res.data.message,
                    type: "warning",
                  });
                }
              },
              (error) => {
                this.formLoading = false;
              }
            );
          }
        });
      }
    },
    // 获取滑动验证码的图片
    getImg(callback) {
      getImageVerifyCode({}).then(
        (res) => {
          callback(res.data);
        },
        (error) => {
          callback(error);
        }
      );
    },
    // 操作滑动后返回值，并传去后端验证
    validImg(blcokLeft, id, callback) {
      console.log(123444);
      // blcokLeft,// 手动定位返回的值
      //   id// 后台返回的id，再传回去
      this.handleLogin(blcokLeft, id, callback); // 登陆请求方法
    },
    handleLogin(blcokLeft, id, callback) {
      if(this.$route.query.type == 'overseas') {
        if (this.extForm.registerEmail) {
          if(/^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/.test(this.extForm.registerEmail)) {
            checkSendEmailCode({
              email: this.extForm.registerEmail,
              checkCodeLimitTime: blcokLeft,
              businessCode: id
            })
              .then((res) => {
                if (res.data.code === "0") {
                  callback({ data: true });
                  this.isCode = false;
                  this.$message({
                    type: "success",
                    message: res.data.message,
                  });
                  this.count = 60;
                  this.timer = setInterval(() => {
                    this.count--;
                    if (this.count === 0) {
                      this.disabled = false;
                      this.count = "";
                      clearInterval(this.timer);
                    }
                  }, 1000);
                  return false;
                } else {
                  clearInterval(this.timer);
                  this.disabled = false;
                  callback({ data: false, message: res.data.message });
                  this.isCode = true;
                }
              })
              .catch((errMessage) => {
                clearInterval(this.timer);
                this.disabled = false;
              });
          } else {
            this.$message({
              showClose: true,
              type: "error",
              message: this.$t("subcontractor.verifyTip.emailVerify"),
              ccuiCustom: true,
            });
          }
        } else {
          this.$message({
            showClose: true,
            type: "error",
            message: this.$t("subcontractor.verifyTip.registerEmail"),
            ccuiCustom: true,
          });
        }
      } else if(this.$route.query.type == 'domestic') {
        if (this.extForm.phone) {
          this.disabled = true;
          if (/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.extForm.phone)) {
            sendVerificationCode({
              phoneNumbers: this.extForm.phone,
              checkCodeLimitTime: blcokLeft,
              businessCode: id,
            })
              .then((res) => {
                if (res.data.code === "0") {
                  callback({ data: true });
                  this.isCode = false;
                  this.$message({
                    type: "success",
                    message: res.data.message,
                  });
                  this.count = 60;
                  this.timer = setInterval(() => {
                    this.count--;
                    if (this.count === 0) {
                      this.disabled = false;
                      this.count = "";
                      clearInterval(this.timer);
                    }
                  }, 1000);
                  return false;
                } else {
                  clearInterval(this.timer);
                  this.disabled = false;
                  callback({ data: false, message: res.data.message });
                  this.isCode = true;
                }
              })
              .catch((errMessage) => {
                clearInterval(this.timer);
                this.disabled = false;
              });
          }else {
            this.$message({
              showClose: true,
              type: "error",
              message: "请输入正确的手机号",
              ccuiCustom: true,
            });
          }
        }
      }
    },
    // 验证码发送
    sendVerification() {
      this.disabled = true;
      // 境外注册
      if(this.$route.query.type == 'overseas') {
        if(/^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/.test(this.extForm.registerEmail)) {
          this.isCode = true;
        } else {
          this.disabled = false;
          this.$message({
            showClose: true,
            type: "error",
            message: this.$t("subcontractor.verifyTip.emailVerify"),
            ccuiCustom: true,
          });
        }
      } else if(this.$route.query.type == 'domestic') {
        if (this.extForm.phone && /^1\d{10}$/.test(this.extForm.phone)) {
          this.isCode = true;
          /* sendVerificationCode({ phoneNumbers: this.extForm.phone }).then(res => {
            if (res.data.message === "发送验证码成功") {
              this.$message({
                type: "success",
                message: res.data.message
              });
              this.count = 60;
              let vClear = setInterval(() => {
                this.count--;
                if (this.count === 0) {
                  this.disabled = false;
                  this.count = "";
                  clearInterval(vClear);
                }
              }, 1000);
              return false;
            } else {
              this.disabled = false;
              this.$message({
                type: "error",
                message: res.data.message
              });
            }
          });*/
        } else {
          this.disabled = false;
          this.$message({
            type: "error",
            message: this.$t("subcontractor.verifyTip.sendPhoneTip"),
          });
        }
      }
    },
    getTreeItem() {
      this.centerDialogVisible = false;
      let treeItem = this.$refs["msgFormSon"].company;
      this.extForm.cooUnitName = treeItem.useOrgName;
      this.extForm.cooUnitCode = treeItem.useOrgCode;
      this.extForm.cooUnitId = treeItem.useOrgId;
      this.extForm.cooUnitExtOid = treeItem.attribute1;
    },
    searInpt(val) {
      this.loadWaite = true;
      qryTycSearch({ word: this.extForm.unifiedCreditCode }).then((res) => {
        this.loadWaite = false;
        if (res.data.code === "0") {
          this.extForm.unifiedCreditCode = "";
          this.extForm.supplierName = "";
          if (res.data.data.result) {
            const info = res.data.data.result;
            // 人员规模 staffNumRange
            console.log(parseInt(info.staffNumRange))
            if (!isNaN(parseInt(info.staffNumRange))){
              this.$set(
                this.subconBaseInfo,
                "companySize",
                parseInt(info.staffNumRange)
              );
            }
            // 成立日期
            this.$set(
              this.subconBaseInfo,
              "companySetupTime",
              formatDate(info.estiblishTime, "yyyy-MM-dd HH:mm:ss")
            );
            //fromTime Number 毫秒数 经营开始时间
            //toTime Number 毫秒数 经营结束时间
            this.$set(this.subconBaseInfo, "fromTime", info.fromTime);
            this.$set(this.subconBaseInfo, "toTime", info.toTime);
            // 注册资本
            if (this.isdecimal(info.regCapital)) {
              this.subconBaseInfo.registeredCapital = info.regCapital.slice(
                0,
                info.regCapital.indexOf("万").toFixed(2)
              );
            } else {
              this.subconBaseInfo.registeredCapital = info.regCapital.slice(
                0,
                info.regCapital.indexOf("万")
              );
            }
            // actualCapital String   实收注册资金
            if(info.actualCapital){
              if (this.isdecimal(info.actualCapital)) {
                this.$set(
                  this.subconBaseInfo,
                  "actualCapital",
                  info.actualCapital.slice(
                    0,
                    info.regCapital.indexOf("万").toFixed(2)
                  )
                );
              } else {
                this.$set(
                  this.subconBaseInfo,
                  "actualCapital",
                  parseInt(
                    info.actualCapital.slice(0, info.regCapital.indexOf("万"))
                  )
                );
              }
            }
            // 企业名称
            this.extForm.supplierName = info.name;
            this.subconBaseInfo.subconName = info.name;
            // regLocation String   注册地址
            this.$set(
              this.subconBaseInfo,
              "registeredAddress",
              info.regLocation
            );
            this.$set(
              this.subconBaseInfo,
              "businessScope",
              info.businessScope
            );
            // 英文名
             if(info.property3){
              this.$set(this.subconBaseInfo, "subconUsName", info.property3);
            }
            // this.$set(this.subconBaseInfo, "subconUsName", info.property3);
            // alias String   简称
            this.$set(this.subconBaseInfo, "subconShortName", info.alias);
            //法人
            this.$set(this.subconBaseInfo, "legalPersonName", info.legalPersonName);
            // historyNames String   曾用名
            this.$set(this.subconBaseInfo, "historyName", info.historyNames);
            // 币种 regCapitalCurrency
            /*this.$set(
                this.subconBaseInfo,
                "currency",
                info.regCapitalCurrency
              );*/
            if (info.creditCode) {
              this.extForm.unifiedCreditCode = info.creditCode;
            } else {
              this.extForm.unifiedCreditCode = "";
              this.extForm.supplierName = "";
            }
            if (this.extForm.unifiedCreditCode === "") {
              this.extForm.supplierName = "";
            }
          } else {
            this.extForm.unifiedCreditCode = "";
            this.extForm.supplierName = "";
            this.$message({
              showClose: true,
              type: "error",
              message: "统一社会信用代码查询失败",
              ccuiCustom: true,
            });
          }
        }
      });
    },
    // 级联选择器修改
    handleChange(value) {
      const obj = this.$refs["demoCascader"].getCheckedNodes();
      this.ruleForm.cooUnitName = obj[0].data.abbrName;
      this.ruleForm.cooUnitId = obj[0].data.orgId;
      this.ruleForm.cooUnitCode = obj[0].data.autoCode;
    },
  },
};
</script>

<style lang="scss" scoped>
.el-form /deep/.el-loading-spinner {
  margin-top: -90px;
  margin-left: -13px;
}
.el-input /deep/.el-loading-mask {
  background: rgba(0, 0, 0, 0.1);
}
.el-input /deep/.el-loading-spinner {
  left: 100%;
  top: 70px;
  img {
    width: 20px;
    height: 20px;
  }
}
.firstStep{
  padding: 0 50px;
  /deep/ .el-form-item{
    margin-bottom: 30px;
    .el-select {
      width: 100%;
    }
    .el-input__inner {
      height: 40px !important;
    }
    .el-date-editor {
      width: 100%;
    } 
  }
  .el-form-item__content .el-button {
    width: 82px;
    height: 40px;
    background: #ff152e;
    border-radius: 2px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    border: none;
    color: #ffffff;
  }
  .verificationCode {
    // width: 435px;
    display: flex;
    .el-button {
      width: 102px;
      height: 40px;
      background: #ffffff;
      border-radius: 2px;
      border: 1px solid #e9ecf7;
      margin-left: 15px;
    }
    .send {
      background: #fff !important;
      border: 1px solid #dddddd;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.85);
    }
  }
}
//滑动窗样式
.islider {
  width: 400px;
  height: 265px;
  background: #ffffff;
  border-radius: 4px;
  box-shadow: 0px 4px 6px 0px rgba(201, 201, 201, 0.5),
    4px 0px 4px 0px rgba(229, 229, 229, 0.5);
  position: absolute;
  top: -278px;
  left: 15px;
}
.islider::before {
  position: absolute;
  bottom: -11px;
  left: 50%;
  content: "";
  border-left: 11px solid transparent;
  border-right: 11px solid transparent;
  border-top: 11px solid rgba(0, 0, 0, 0.1);
}
.islider::after {
  position: absolute;
  bottom: -11px;
  left: 50%;
  content: "";
  border-left: 11px solid transparent;
  border-right: 11px solid transparent;
  border-top: 11px solid #ffffff;
  filter: drop-shadow(1px 3px 1px rgba(0, 0, 0, 0.2));
}
.confirmButton {
  margin-top: 20px;
}
</style>
